import { Bubble } from 'js/bubbleCore/bubbles/types';
import { IGameData, Place } from 'js/bubbleCore/types';
import { removeFromSpace } from 'js/bubbleCore/utils/removeFromSpace';
import { removeItem } from 'framework/utils/array-utils';
import { removeFromGrid } from 'js/bubbleCore/utils/removeFromGrid';

export function removeFromPlace(bubble: Bubble, data: IGameData, place: Place): void {
  if (place === Place.Grid) {
    removeFromGrid(data.grid, bubble.col, bubble.row);
  } else if (place === Place.Shooter) {
    removeItem(data.shooter.bubblesQueue, bubble);
  } else if (place === Place.ShootingSpace) {
    removeFromSpace(data.shootingSpace, bubble);
  } else if (place === Place.PopOutSpace) {
    removeFromSpace(data.popOutSpace, bubble);
  }
}